import { render, staticRenderFns } from "./editrefferalPartner.vue?vue&type=template&id=5a453cb8&"
import script from "./editrefferalPartner.vue?vue&type=script&lang=js&"
export * from "./editrefferalPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports